import React from 'react';

interface PcWideCardSkeletonProps {
  width?: string | number;
  height?: string | number;
  className?: string;
}

const PcWideCardSkeleton = ({
  width = 845,
  height = 400,
  className = '',
}: PcWideCardSkeletonProps) => {
  return (
    <div
      className={`bg-secondary-white rounded-[32px] py-[16px] pl-[16px] pr-[40px] flex items-center shadow-[0_6px_40px_rgba(0,0,0,0.06)] animate-pulse ${className}`}
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
      }}
    >
      {/* 이미지 영역 */}
      <div className="w-[503px] h-[368px] bg-gray-200 rounded-[16px]"></div>

      {/* 텍스트 영역 */}
      <div className="relative w-[246px] h-[304px] ml-[40px]">
        {/* 제목 스켈레톤 */}
        <div className="h-[28px] bg-gray-200 rounded-[4px] w-full mb-[18px]"></div>
        <div className="h-[28px] bg-gray-200 rounded-[4px] w-4/5 mb-[16px]"></div>

        {/* 내용 스켈레톤 */}
        <div className="h-[18px] bg-gray-200 rounded-[4px] w-full mb-[10px]"></div>
        <div className="h-[18px] bg-gray-200 rounded-[4px] w-full mb-[10px]"></div>
        <div className="h-[18px] bg-gray-200 rounded-[4px] w-3/4 mb-[10px]"></div>
        <div className="h-[18px] bg-gray-200 rounded-[4px] w-4/5 mb-[10px]"></div>
        <div className="h-[18px] bg-gray-200 rounded-[4px] w-1/2"></div>

        {/* 버튼 스켈레톤 */}
        <div className="absolute bottom-[0px] right-[0px] w-[56px] h-[56px] bg-gray-200 rounded-full"></div>
      </div>
    </div>
  );
};

export default PcWideCardSkeleton;
